import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getLocalStorage } from '../helpers/helper';

@Injectable({
  providedIn: 'root'
})
export class DocumentManagementService {
  Url = `${environment.url.api}`;
  private headers: HttpHeaders;
  /**
   * Constructor del servicio
   * @param http Servicio para realizar llamnadas HTTP
   */
  constructor(private http: HttpClient) {
    const token = getLocalStorage('token');
    this.headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*'
    });
    this.headers = this.headers.append(
      'Authorization',
      'Bearer ' + token.access_token
    );
  }

  /**
   * Servicio que retorna los documentos asociados a un tipo.
   * @param typeDoc Tipo de documento
   * @returns Documentos asociados al tipo de documento
   */
  public GetDocument(typeDoc : string): Observable<any> {
    const url = `${this.Url}/com/documentsManagement/Documents?Name=${typeDoc}`;
    const httpOptions = { headers: this.headers };
    const resp = this.http.get<any>(url, httpOptions);
    return resp;
  }

  /**
   * @param documentId Id del documento encontrado
   * @param rut Rut del cliente a firmar
   * @param result all / last
   * @returns Retorna la(s) firma(s) asociada(s) al rut ingresado.
   */
  public DocumentSignature(
    documentId : number,
    rut : string,
    result : string
  ) : Observable<any> {
    const url = `${this.Url}/com/documentsManagement/Document/${documentId}/Client/${rut}/Signature?results=${result}`;
    const httpOptions = { headers: this.headers };
    const resp = this.http.get<any>(url, httpOptions);
    return resp;
  }
}
